import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledRentalDirectory,

  /* Cells */
  StyledCellOrder,
  StyledCellPos,
  StyledCellText,
  StyledCellStation,
  StyledCellPrice,
  StyledCellDate,
  IconButton
} from './style';

import { Arrow } from '../../../../../assets/images/index';

class RowDirectory extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = { active: false };
  }

  onClick() {
    const { active } = this.state;
    this.setState({ active: !active });
  }

  render() {
    const { dataRow } = this.props;

    return (
      <StyledRentalDirectory active={this.state.active}>
        <IconButton
          svg={Arrow}
          size="s"
          hover
          active={this.state.active}
          onClick={this.onClick}
        />
        <StyledCellStation title={dataRow.radioBroadcasterName}>
          {' '}
          {dataRow.radioBroadcasterName}{' '}
        </StyledCellStation>

        <StyledCellText title={dataRow.text}>{dataRow.text}</StyledCellText>
        <StyledCellPos title={dataRow.position}>
          {' '}
          {dataRow.position}{' '}
        </StyledCellPos>
        <StyledCellOrder title={dataRow.order}>
          {' '}
          {dataRow.order}{' '}
        </StyledCellOrder>
        <StyledCellPrice title={dataRow.price}>{dataRow.price}</StyledCellPrice>
        <StyledCellDate title={dataRow.date}> {dataRow.date} </StyledCellDate>
        <StyledCellDate title={dataRow.sapCode}>
          {' '}
          {dataRow.sapCode}{' '}
        </StyledCellDate>
        <StyledCellDate title={dataRow.providerName}>
          {' '}
          {dataRow.providerName}{' '}
        </StyledCellDate>
      </StyledRentalDirectory>
    );
  }
}

RowDirectory.propTypes = {
  dataRow: PropTypes.shape({
    name: PropTypes.string,
    lastname: PropTypes.string,
    profile: PropTypes.string,
    department: PropTypes.string,
    extension: PropTypes.number,
    phones: PropTypes.string,
    email: PropTypes.string,
    chatUrl: PropTypes.string
  })
};

RowDirectory.defaultProps = {
  dataRow: {
    chatUrl: 'https://teams.microsoft.com/'
  }
};

export default RowDirectory;
